(() => {
  const roots = new Set();

  const getActiveRegion = (root) => {
    return root.querySelector('[data-size-guide-region-filter][aria-pressed="true"]')?.dataset.sizeGuideRegion || 'us';
  };

  const getActivePanel = (root) => {
    return root.querySelector('[data-size-guide-panel]:not([hidden])') || root.querySelector('[data-size-guide-panel]');
  };

  const syncRegion = (root, region) => {
    root.querySelectorAll('[data-size-guide-region-filter]').forEach((button) => {
      if (!(button instanceof HTMLButtonElement)) return;

      button.setAttribute('aria-pressed', String(button.dataset.sizeGuideRegion === region));
    });

    const hasRegionalContent = window.WobSizeGuideTables?.syncRegion(root, getActivePanel(root), region) || false;
    const filter = root.querySelector('[data-size-guide-region-filter-wrap]');

    if (filter instanceof HTMLElement) {
      filter.hidden = !hasRegionalContent;
    }
  };

  const setActiveTab = (root, tab, shouldFocus = false) => {
    if (!(tab instanceof HTMLElement)) return;

    const target = tab.dataset.sizeGuideTarget;

    root.querySelectorAll('[data-size-guide-tab]').forEach((item) => {
      if (!(item instanceof HTMLElement)) return;

      const isSelected = item === tab;

      item.setAttribute('aria-selected', String(isSelected));
      item.tabIndex = isSelected ? 0 : -1;
    });

    root.querySelectorAll('[data-size-guide-panel]').forEach((panel) => {
      if (!(panel instanceof HTMLElement)) return;

      panel.hidden = panel.dataset.sizeGuidePanel !== target;
    });

    syncRegion(root, getActiveRegion(root));

    window.requestAnimationFrame(() => {
      tab.scrollIntoView({ block: 'nearest', inline: 'center' });
    });

    if (shouldFocus) {
      tab.focus({ preventScroll: true });
    }
  };

  const initRoot = (root) => {
    if (!(root instanceof HTMLElement) || roots.has(root)) return;

    roots.add(root);
    root.querySelectorAll('[data-size-guide-panel]').forEach((panel) => window.WobSizeGuideTables?.prepare(panel));

    const tabs = Array.from(root.querySelectorAll('[data-size-guide-tab]'));
    const selectedTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];

    if (selectedTab instanceof HTMLElement) {
      setActiveTab(root, selectedTab);
    } else {
      syncRegion(root, getActiveRegion(root));
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => setActiveTab(root, tab));

      tab.addEventListener('keydown', (event) => {
        const isForward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
        const isBackward = event.key === 'ArrowLeft' || event.key === 'ArrowUp';

        if (!isForward && !isBackward) return;

        event.preventDefault();
        const direction = isForward ? 1 : -1;
        const nextTab = tabs[(index + direction + tabs.length) % tabs.length];

        setActiveTab(root, nextTab, true);
      });
    });

    root.querySelectorAll('[data-size-guide-region-filter]').forEach((button, index, buttons) => {
      button.addEventListener('click', () => {
        syncRegion(root, button.dataset.sizeGuideRegion || 'us');
      });

      button.addEventListener('keydown', (event) => {
        const isForward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
        const isBackward = event.key === 'ArrowLeft' || event.key === 'ArrowUp';

        if (!isForward && !isBackward) return;

        event.preventDefault();
        const direction = isForward ? 1 : -1;
        const nextButton = buttons[(index + direction + buttons.length) % buttons.length];

        if (!(nextButton instanceof HTMLButtonElement)) return;

        syncRegion(root, nextButton.dataset.sizeGuideRegion || 'us');
        nextButton.focus({ preventScroll: true });
      });
    });
  };

  const init = (container = document) => {
    container.querySelectorAll?.('[data-size-guide-static]').forEach(initRoot);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
